import React from 'react';
import { withRouter } from 'Components/withRouter';
import styles from './BookingOptionsEditForm.module.css';

class BookingOptionsEditForm extends React.Component {

    constructor(props) {
        super(props);

        var initialState = {
            account: "",
            ref1_required: false,
            ref2_required: false,
            include_price_markup: false
        };

        if (props.bookingOptions) {
            Object.assign(initialState, {
                account: props.bookingOptions.account,
                ref1_required: props.bookingOptions.ref1_required,
                ref2_required: props.bookingOptions.ref2_required,
                include_price_markup: props.bookingOptions.include_price_markup
            });
        }

        this.state = initialState;

        this.handleChange = this.handleChange.bind(this);
        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.bookingOptions && this.props.bookingOptions !== prevProps.bookingOptions) {
            this.setState({
                account: this.props.bookingOptions.account,
                ref1_required: this.props.bookingOptions.ref1_required,
                ref2_required: this.props.bookingOptions.ref2_required,
                order_number_required: this.props.bookingOptions.order_number_required,
                include_price_markup: this.props.bookingOptions.include_price_markup
            });
        }
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: (event.target.type === 'checkbox') ? event.target.checked: event.target.value
        })
    }

    handleAccountChange(event) {

        if (this.props.onAccountChange) {
            this.props.onAccountChange(event.target.value);
        }
    }

    handleSubmit(event) {

        event.preventDefault();

        const formData = new FormData(document.getElementById('bookingOptionsForm'));

        if (this.props.onFormSubmit) {
            this.props.onFormSubmit(formData);
        }

    }

    handleCancel(event) {
        if (this.props.router.navigate) {
            this.props.router.navigate(-1);
        }
    }

    render() {

        var accountOptions = null;

        if (this.props.accounts) {
            var sortedAccounts = _.sortBy(this.props.accounts, ['label']);
            accountOptions = sortedAccounts.map(
                (a) => <option key={a.value} value={a.value}>{a.label}</option>
                );
        }

        return (
            <form id="bookingOptionsForm" styleName="styles.form" onSubmit={this.handleSubmit}>
                <div className="row">
                    <div className="col-xs-12 col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6 col-lg-offset-4 col-lg-4">
                        <div className="form-group form-group-sm">
                            <label htmlFor="inputAccount">Deadline Account</label>
                            <select className="form-control" name="account" value={this.state.account} onChange={this.handleAccountChange}>
                                {accountOptions}
                            </select>
                        </div>
                        <div className="checkbox">
                            <label htmlFor="inputRef1">
                            <input id="inputRef1" name="ref1_required" type="checkbox" checked={this.state.ref1_required} onChange={this.handleChange}/>Ref 1 Required
                            </label>
                        </div>
                        <div className="checkbox">
                            <label htmlFor="inputRef2">
                                <input id="inputRef2" name="ref2_required" type="checkbox" checked={this.state.ref2_required} onChange={this.handleChange}/>Ref 2 Required
                            </label>
                        </div>
                        <div className="checkbox">
                            <label htmlFor="inputIncludePriceMarkup">
                                <input id="inputIncludePriceMarkup" name="include_price_markup" type="checkbox" checked={this.state.include_price_markup} onChange={this.handleChange}/>Include Price Markup
                            </label>
                        </div>
                        <button type="submit" className="btn btn-default btn-dl-green">SAVE</button>
                        <button type="button" className="btn btn-default btn-dl-green margin-lr10" onClick={this.handleCancel}>CANCEL</button>
                    </div>
                </div>
            </form>
        );
    }

}

export default withRouter(BookingOptionsEditForm);